
import React, { useEffect, useState } from 'react';
import { View } from '../types';
import { PawPrint } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

interface PublicNavbarProps {
    onNavigate: (view: View) => void;
}

export const PublicNavbar: React.FC<PublicNavbarProps> = ({ onNavigate }) => {
    const { user } = useAuth();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (user) return null;

    return (
        <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-xl shadow-sm py-3 md:py-4' : 'bg-transparent py-4 md:py-6'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-0">
                
                {/* Logo and Acceder for Mobile */}
                <div className="flex w-full md:w-auto items-center justify-between">
                    <div
                        className="flex items-center gap-2 cursor-pointer"
                        onClick={() => onNavigate(View.LANDING)}
                    >
                        <img src="/logo.png" alt="Amigo Peludo" className="h-10 md:h-12 w-auto object-contain" />
                    </div>
                    <div className="flex items-center md:hidden">
                        <button
                            onClick={() => onNavigate(View.LOGIN)}
                            className="px-4 py-2.5 bg-slate-900 shadow-lg shadow-slate-900/20 text-white rounded-xl font-black uppercase text-[9px] tracking-widest hover:bg-orange-500 transition-all active:scale-95"
                        >
                            Acceder
                        </button>
                    </div>
                </div>

                {/* Navigation Links */}
                <div className="flex items-center gap-4 sm:gap-8 w-full md:w-auto justify-center overflow-x-auto pb-1 md:pb-0 hide-scrollbar">
                    <button onClick={() => onNavigate(View.LANDING)} className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-500 hover:text-orange-500 transition-colors whitespace-nowrap">Inicio</button>
                    <button onClick={() => onNavigate(View.PET_PROFILES)} className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-500 hover:text-orange-500 transition-colors whitespace-nowrap">Mascotas</button>
                    <button onClick={() => onNavigate(View.GPS_TRACKING)} className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-500 hover:text-orange-500 transition-colors whitespace-nowrap">Mapa</button>
                    <button onClick={() => onNavigate(View.LOST_PETS_HALL)} className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-500 hover:text-orange-500 transition-colors whitespace-nowrap">SOS</button>
                </div>

                {/* Acceder for Desktop */}
                <div className="hidden md:flex items-center gap-2 flex-shrink-0">
                    <button
                        onClick={() => onNavigate(View.LOGIN)}
                        className="px-6 py-3 bg-slate-900 shadow-lg shadow-slate-900/20 text-white rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-500 transition-all hover:scale-105"
                    >
                        Acceder
                    </button>
                </div>

            </div>
        </nav>
    );
};
